
{
  "familyId": "SWW-TT-MEERVOUD",
  "questions": [
    {
      "id": "SWW-TT-MEERVOUD-001",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Welke vorm is correct?\n'Wij ... elke dag naar school.'",
      "context": null,
      "options": ["lopen", "loopt", "loop", "loopt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meervoud tegenwoordige tijd", "content": "Bij wij/jullie/zij gebruik je de infinitief (de basisvorm): lopen, werken, spelen. Niet de stam! Stam = lop, werk, speel.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "tt_meervoud_wij",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Bij 'wij' gebruik je de infinitief (basisvorm) van het werkwoord. De infinitief van 'lopen' is 'lopen'. Dus: wij lopen.",
        "distractorExplanations": {
          "0": "Correct! Bij 'wij' gebruik je de infinitief: wij lopen.",
          "1": "Fout: 'loopt' gebruik je bij 'hij/zij/het' (enkelvoud): hij loopt. Bij 'wij' gebruik je de infinitief: wij lopen.",
          "2": "Fout: 'loop' is de stam en gebruik je bij 'ik': ik loop. Bij 'wij' gebruik je de infinitief: wij lopen.",
          "3": "Fout: 'loopt' is voor 'hij/zij/het'. Bij 'wij' gebruik je de infinitief: wij lopen."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-002",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Welke vorm is correct?\n'Jullie ... heel hard.'",
      "context": null,
      "options": ["werken", "werkt", "werk", "werkten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meervoud tegenwoordige tijd", "content": "Bij wij/jullie/zij gebruik je de infinitief: werken, lopen, spelen. De infinitief eindigt altijd op -en.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "tt_meervoud_jullie",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Bij 'jullie' gebruik je de infinitief van het werkwoord. De infinitief van 'werken' is 'werken'. Dus: jullie werken.",
        "distractorExplanations": {
          "0": "Correct! Bij 'jullie' gebruik je de infinitief: jullie werken.",
          "1": "Fout: 'werkt' gebruik je bij 'hij/zij/het': hij werkt. Bij 'jullie' gebruik je de infinitief: jullie werken.",
          "2": "Fout: 'werk' is de stam en gebruik je bij 'ik': ik werk. Bij 'jullie' gebruik je de infinitief: jullie werken.",
          "3": "Fout: 'werkten' is de verleden tijd (meervoud). Bij 'jullie' in de tegenwoordige tijd gebruik je de infinitief: jullie werken."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-003",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Welke vorm is correct?\n'Zij ... graag voetbal.'",
      "context": null,
      "options": ["spelen", "speelt", "speel", "gespeeld"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meervoud tegenwoordige tijd", "content": "Wij/jullie/zij → infinitief (basisvorm op -en)\nIk → stam\nJij/hij/zij/het → stam + t", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "tt_meervoud_zij",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Bij 'zij' (meervoud = zij allen) gebruik je de infinitief: spelen. Let op: 'zij speelt' kan ook correct zijn als 'zij' enkelvoud is (één persoon). Maar bij meervoud (meerdere personen) is het altijd de infinitief: zij spelen.",
        "distractorExplanations": {
          "0": "Correct! Bij 'zij' (meervoud) gebruik je de infinitief: zij spelen.",
          "1": "Fout: 'speelt' gebruik je bij 'hij/zij/het' (enkelvoud, één persoon). Bij meervoud gebruik je de infinitief: zij spelen.",
          "2": "Fout: 'speel' is de stam en gebruik je bij 'ik': ik speel. Bij 'zij' (meervoud) gebruik je de infinitief: zij spelen.",
          "3": "Fout: 'gespeeld' is het voltooid deelwoord. Bij 'zij' (meervoud) in de tegenwoordige tijd gebruik je de infinitief: zij spelen."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-004",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "context": null,
      "options": [
        "Wij zingt een liedje.",
        "Wij zingen een liedje.",
        "Wij zingt een liedje.",
        "Wij gezongen een liedje."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meervoud tegenwoordige tijd", "content": "Bij wij/jullie/zij gebruik je de infinitief (basisvorm): zingen, lopen, werken. Nooit de stam+t bij meervoud!", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "tt_meervoud_zin_correct",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Bij 'wij' gebruik je de infinitief van het werkwoord. De infinitief van 'zingen' is 'zingen'. Dus: wij zingen.",
        "distractorExplanations": {
          "0": "Fout: 'zingt' gebruik je bij 'hij/zij/het' (enkelvoud). Bij 'wij' gebruik je de infinitief: wij zingen.",
          "1": "Correct! Bij 'wij' gebruik je de infinitief: wij zingen.",
          "2": "Fout: 'zingt' is voor enkelvoud (hij/zij/het). Bij 'wij' gebruik je de infinitief: wij zingen.",
          "3": "Fout: 'gezongen' is het voltooid deelwoord. Bij 'wij' in de tegenwoordige tijd gebruik je de infinitief: wij zingen."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-005",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Welke vorm hoort bij 'wij'?\nWerkwoord: 'fietsen'",
      "context": null,
      "options": ["fietsen", "fietst", "fiets", "gefietst"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Overzicht vormen", "content": "ik → fiets (stam)\njij/hij/zij/het → fietst (stam + t)\nwij/jullie/zij → fietsen (infinitief)", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "tt_meervoud_overzicht",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Overzicht: ik fiets (stam), jij/hij fietst (stam+t), wij/jullie/zij fietsen (infinitief). Bij 'wij' gebruik je altijd de infinitief: fietsen.",
        "distractorExplanations": {
          "0": "Correct! Bij 'wij' gebruik je de infinitief: wij fietsen.",
          "1": "Fout: 'fietst' gebruik je bij 'jij/hij/zij/het' (enkelvoud). Bij 'wij' gebruik je de infinitief: fietsen.",
          "2": "Fout: 'fiets' is de stam en gebruik je bij 'ik': ik fiets. Bij 'wij' gebruik je de infinitief: fietsen.",
          "3": "Fout: 'gefietst' is het voltooid deelwoord. Bij 'wij' in de tegenwoordige tijd gebruik je de infinitief: fietsen."
        }
      }
    }
  ]
}
